<template>
  <div>
    <div
      class="card"
      v-if="showFormJenisPelaporan"
    >
      <div class="card-header">
        <h4>Jenis Pelaporan</h4>
      </div>
      <div class="card-body">
        <FormJenisPelaporan
          @loadForm="loadForm"
          :disabled-form="disabledForm"
        />
      </div>
    </div>

    <div
      class="list-formulir"
      role="tablist"
      v-if="showForm"
    >
      <div v-if="formDiisi.length > 0">
        <b-card
          no-body
          class="mb-1"
          v-for="f in formDiisi"
          :key="f.id"
        >
          <b-card-header
            header-tag="header"
            class="p-0"
            role="tab"
            style="min-height:inherit;border-radius:3px;cursor:pointer"
          >
            <div
              v-b-toggle="'form-'+f.id"
              class="p-3 d-flex"
              :class="{'bg-success text-white' : f.form_data}"
              style="width:100%;border-radius:3px"
            >
              <b :class="{'text-primary': !f.form_data, 'text-white':f.form_data}">
                {{ f.nama_form }} <span
                  v-if="f.is_wajib === 1"
                  class="text-dark"
                >(Wajib)</span>
              </b>
              <div style="margin-left:auto">
                <i
                  class="fa text mr-2" 
                  :class="{'fa-check-circle' : f.form_data, 'fa-info-circle text-warning' : !f.form_data}"
                />
              </div>
            </div>
          </b-card-header>
          <b-collapse
            :id="'form-'+f.id"
            role="tabpanel"
            accordion="list-formulir"
          >
            <b-card-body>
              <component
                :is="f.component"
                :disabled-form="disabledForm"
                :is-wajib="f.is_wajib"
                :data="f.form_data"
                @handleSuccess="handleSuccess"
              />
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
      <div v-else>
        Tidak ada form yang diisi
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert'

import FormJenisPelaporan from './../form/Pelaporan/FormJenisPelaporan.vue'
import FormPelaporanKelahiran from './../form/Pelaporan/FormPelaporanKelahiran.vue'
import FormPelaporanCapilLuarNKRI from './../form/Pelaporan/FormPelaporanCapilLuarNKRI.vue'
import FormPelaporanDataOrangtua from './../form/Pelaporan/FormPelaporanDataOrangtua.vue'
import FormPelaporanKematian from './../form/Pelaporan/FormPelaporanKematian.vue'
import FormPelaporanPelapor from './../form/Pelaporan/FormPelaporanPelapor.vue'
import FormPelaporanSaksi from './../form/Pelaporan/FormPelaporanSaksi.vue'
import FormPelaporanLahirMati from './../form/Pelaporan/FormPelaporanLahirMati.vue'
import FormPelaporanPembetulanPembatalanAkta from './../form/Pelaporan/FormPelaporanPembetulanPembatalanAkta.vue'
import FormPelaporanPengakuanAnak from './../form/Pelaporan/FormPelaporanPengakuanAnak.vue'
import FormPelaporanPengangkatanAnak from './../form/Pelaporan/FormPelaporanPengangkatanAnak.vue'
import FormPelaporanPengesahanAnak from './../form/Pelaporan/FormPelaporanPengesahanAnak.vue'
import FormPelaporanPerceraian from './../form/Pelaporan/FormPelaporanPerceraian.vue'
import FormPelaporanPeristiwaPenting from './../form/Pelaporan/FormPelaporanPeristiwaPenting.vue'
import FormPelaporanPerkawinan from './../form/Pelaporan/FormPelaporanPerkawinan.vue'
import FormPelaporanPerubahanNama from './../form/Pelaporan/FormPelaporanPerubahanNama.vue'
import FormPelaporanPerubahanStatusKewarganegaraan from './../form/Pelaporan/FormPelaporanPerubahanStatusKewarganegaraan.vue'
import FormPelaporanSubjekAktaKedua from './../form/Pelaporan/FormPelaporanSubjekAktaKedua.vue'
import FormPelaporanSubjekAktaKesatu from './../form/Pelaporan/FormPelaporanSubjekAktaKesatu.vue'
import FormBiodata from './../form/Biodata/FormBiodata.vue'
import FormBiodataWni from './../form/BiodataWni/FormBiodataWni.vue'
import FormPendaftaranKependudukan from './../form/PendaftaranKependudukan/FormPendaftaranKependudukan.vue'
import FormPendaftaranPerpindahanPenduduk from './../form/PendaftaranPerpindahanPenduduk/FormPendaftaranPerpindahanPenduduk.vue'
import FormSkPindahLuarNegeri from './../form/SkPindahLuarNegeri/FormSkPindahLuarNegeri.vue'
import FormSpPerubahanData from './../form/SpPerubahanData/FormSpPerubahanData.vue'
import FormSpTidakMemilikiDokumen from './../form/SpTidakMemilikiDokumen/FormSpTidakMemilikiDokumen.vue'
import FormSptjmKawinBelumCatat from './../form/SptjmKawinBelumCatat/FormSptjmKawinBelumCatat.vue'
import FormSptjmKelahiran from './../form/SptjmKelahiran/FormSptjmKelahiran.vue'
import FormSptjmSuamiIstri from './../form/SptjmSuamiIstri/FormSptjmSuamiIstri.vue'
import FormPendudukNonPermanen from './../form/PendudukNonPermanen/FormPendudukNonPermanen.vue'

export default {
    data() {
        return {
            showForm: true,
            showFormJenisPelaporan: false,
        }
    },
    props: {
        disabledForm: Boolean
    },
    components: {
        FormJenisPelaporan,
        FormPelaporanKelahiran,
        FormPelaporanCapilLuarNKRI,
        FormPelaporanDataOrangtua,
        FormPelaporanKematian,
        FormPelaporanPelapor,
        FormPelaporanSaksi,
        FormPelaporanLahirMati,
        FormPelaporanPembetulanPembatalanAkta,
        FormPelaporanPengakuanAnak,
        FormPelaporanPengangkatanAnak,
        FormPelaporanPengesahanAnak,
        FormPelaporanPerceraian,
        FormPelaporanPeristiwaPenting,
        FormPelaporanPerkawinan,
        FormPelaporanPerubahanNama,
        FormPelaporanPerubahanStatusKewarganegaraan,
        FormPelaporanSubjekAktaKedua,
        FormPelaporanSubjekAktaKesatu,
        FormBiodata,
        FormBiodataWni,
        FormPendaftaranKependudukan,
        FormPendaftaranPerpindahanPenduduk,
        FormSkPindahLuarNegeri,
        FormSpPerubahanData,
        FormSpTidakMemilikiDokumen,
        FormSptjmKawinBelumCatat,
        FormSptjmKelahiran,
        FormSptjmSuamiIstri,
        FormPendudukNonPermanen
    },
    computed: {
        dataPermohonan(){
            return this.$store.getters.getDataPermohonan
        },
        layananSelected(){
            return this.$store.getters.getLayananSelected
        },
        namaRole(){
            return this.$store.getters.getAuthService.currentRole.nama_role
        },
        formDiisi(){
            let formDiisi = []
            this.dataPermohonan.form.forEach(e => {
                if(e.form_data){
                    formDiisi.push(e)
                }
            })
            // console.log(formDiisi)
            return formDiisi
            // return this.dataPermohonan.form.filter(e => e.form.form_data)
        }
    },
    methods: {
        loadForm(){
            let idDataPermohonan = this.dataPermohonan.id_data_permohonan
            let dispatch = 'showDataPermohonanPenduduk'
            if(this.namaRole == 'Penduduk'){
                dispatch = 'showDataPermohonanPenduduk'
            } else if(this.namaRole == 'Operator Desa' || this.namaRole == 'Kepala Desa'){
                dispatch = 'showDataPermohonanPendudukByDesa'
            } else if(this.namaRole == 'Operator Kecamatan'){
                dispatch = 'showDataPermohonanPendudukByKecamatan'
            } else if(this.namaRole == 'Operator Dukcapil' || this.namaRole == 'Operator Dukcapil Kecamatan'){
                dispatch = 'showDataPermohonanPendudukByDukcapil'
            }
            
            this.$store.dispatch(dispatch, idDataPermohonan)
        },
        handleSuccess(){
            let idDataPermohonan = this.dataPermohonan.id_data_permohonan
            let dispatch = 'showDataPermohonanPenduduk'
            if(this.namaRole == 'Penduduk'){
                dispatch = 'showDataPermohonanPenduduk'
            } else if(this.namaRole == 'Operator Desa' || this.namaRole == 'Kepala Desa'){
                dispatch = 'showDataPermohonanPendudukByDesa'
            } else if(this.namaRole == 'Operator Kecamatan'){
                dispatch = 'showDataPermohonanPendudukByKecamatan'
            } else if(this.namaRole == 'Operator Dukcapil' || this.namaRole == 'Operator Dukcapil Kecamatan'){
                dispatch = 'showDataPermohonanPendudukByDukcapil'
            }
            
            this.$store.dispatch(dispatch, idDataPermohonan)
            
        },
        checkHasFormPelaporan(){
            // jika punya form pelaporan
            let form = this.dataPermohonan.paket_layanan.layanan.layanan_dokumen
            
            let isHasFormPelaporan = false
            form.forEach(e => {
                if(e.dokumen.kode_dokumen === 'F2.01'){
                    isHasFormPelaporan = true
                }
            })

            this.showFormJenisPelaporan = isHasFormPelaporan
        },
        initFormPelaporan(){
            let role = this.$store.getters.getAuthService.currentRole.nama_role

            let formPelaporan = new FormData()
            let idDataPermohonan = this.dataPermohonan.id_data_permohonan
            formPelaporan.append('id_data_permohonan', idDataPermohonan)

            let dispatchPelaporan = 'storeFormPelaporan'

            if(role === 'Operator Desa'){
                formPelaporan.append('id_penduduk', this.$store.getters.getPendudukBantu.id_penduduk)
            }

            
            this.$store.dispatch(dispatchPelaporan, formPelaporan).then(res => {
                // console.log(res)
                if(res.data.status){
                    this.$store.dispatch('setFormPelaporan', res.data.data)
                }
            })
        },
    },
    created(){
        if(this.dataPermohonan.id_data_permohonan){
            this.checkHasFormPelaporan()
            this.initFormPelaporan()
        }
    },
    watch: {
        dataPermohonan(newVal){
            if(newVal.is_form_online === 1){
                this.checkHasFormPelaporan()
                this.initFormPelaporan()
            }
        }
    }

}
</script>
